import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UpdateDataService } from '../core/update-data.service';
import { NGXLogger } from 'ngx-logger';
import { combineLatest, map } from 'rxjs';

export const systemReadyGuard: CanActivateFn = (route, state) => {
  const updateDataService = inject(UpdateDataService);
  const router = inject(Router);
  const logger = inject(NGXLogger);

  logger.log('Checking if system is ready');

  return combineLatest([
    updateDataService.accountsSet$,
    updateDataService.usersSet$,
    updateDataService.staffsSet$
  ]).pipe(
    map(([accountsSet, usersSet, staffsSet]) => {
      if (accountsSet && usersSet && staffsSet) {
        logger.log('System is ready');
        return true;
      } else {
        logger.log('System is not ready. Redirecting to landing page.');

        const path = state.url.split('?')[0];
        const queryParams = router.parseUrl(state.url.replace(path, '')).queryParams;

        const url = router.parseUrl(`/?origin=${path}`);

        for (const kvp of Object.entries(queryParams)) {
          if (kvp[0] !== 'origin') {
            url.queryParams[kvp[0]] = kvp[1];
          }
        }

        return url;
      }
    })
  );
};
